// extracted by mini-css-extract-plugin
module.exports = {"container":"DayActivityChartTooltip_container__1kII9","date":"DayActivityChartTooltip_date__20qTl"};